import {ellipsis} from 'polished';
import React, {FC} from 'react';
import styled from 'styled-components';

import {TeammateModel} from '../../../libs/shared/core/src/models/api/teammateModel';
import {buildTeammateDisplayName} from '../../../libs/shared/core/src/models/helpers/teammateModelHelpers';
import {VisualSizesEnum} from '../../../libs/shared/ui/src/styles/commonStyles';
import {fontSizes, fontWeights} from '../../../libs/shared/ui/src/styles/fontStyles';
import {useUserTheme} from '../../../libs/shared/ui/src/theme/userThemeProvider';
import {useAvailabilityStatus} from '../../../srcCommon/app/availabilityStatusHooks';
import {TeammateAvatarWithStatus} from '../common/avatars/teammateAvatarWithStatus';

/*
 * Props.
 */

interface TeammateCardProfileProps {
  teammate: TeammateModel;
}

/*
 * Style.
 */

const StyledProfileDiv = styled.div`
  display: flex;
  height: 80px;
  padding: 16px 16px 16px 16px;
  gap: 16px;
`;

const StyledProfileAttributesDiv = styled.div`
  height: 100%;
  display: flex;
  gap: 5px;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
`;

const StyledProfileNameDiv = styled.div`
  color: ${(p) => p.theme.greys.shade80};
  font-size: ${fontSizes.veryLarge};
  font-weight: ${fontWeights.bold};
  ${ellipsis()};
`;

/*
 * Component.
 */

export const TeammateCardProfile: FC<TeammateCardProfileProps> = (props) => {
  const {teammate} = props;
  const theme = useUserTheme();
  const availabilityStatus = useAvailabilityStatus();

  return (
    <StyledProfileDiv>
      <TeammateAvatarWithStatus
        teammate={teammate}
        size={VisualSizesEnum.EXTRA_LARGE}
        borderColor={theme.foreground}
        availabilityStatus={availabilityStatus.type}
        teammateStatus={teammate.availabilityStatus}
      />
      <StyledProfileAttributesDiv>
        <StyledProfileNameDiv>{buildTeammateDisplayName(teammate)}</StyledProfileNameDiv>
      </StyledProfileAttributesDiv>
    </StyledProfileDiv>
  );
};
